export enum MicrotaskType {
	Unknown = -1,
	RestApiReceiver = 0,
	DataMapper = 1,
	RestApiSender = 2,
	IfGate = 3,
	SalesforceGetObjects = 4,
	ScheduleTask = 5,
	HubspotSaveObjects = 6,
	HubspotGetObjects = 7,
	DataSchema = 8,
	SalesforceSaveObjects = 9,
	HubspotWebhook = 10,
	ParallelSplit = 11,
	ArrayToRecords = 12,
	ScriptBlock = 13,
	ExecuteFlow = 14,
	SetVariable = 15,
	GetVariable = 16,
	RateLimiter = 17,
	ParallelJoin = 18,
	ClearData = 19,
	Delay = 20,
	DatabaseConnector = 21,
	ArrayComparison = 22,
	Validation = 23,
	Batching = 24,
	SFTPReader = 25,
	SFTPWriter = 26,
	S3Reader = 27,
	S3Writer = 28,
	HubspotSaveAssociations = 29,
	Loop = 30,
	HubspotDeleteObjects = 31,
	MergeData = 32,
	TakeFromArray = 33,
	Notification = 34,
	CustomLog = 35,
	ShopifyWebhook = 36,
	GoogleSheetsQuery = 37,
	SortData = 38,
	HubspotGetAssociations = 39,
	DuplicateValueCheck = 40,
	XeroCreateInvoice = 41,
	AddItem = 42,
}
